import BGImage from '../assets/background.jpg';
const datas={
    "url":"https://uvtv-Mso.Impactsms.in",
    "BG-Image":BGImage,
    "blueColor":"#040B26"
}
export default datas;